import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import ContattiHero from './components/ContattiHero';
import FormConsulenza from './components/FormConsulenza';
import PreAnalisiInfo from './components/PreAnalisiInfo';
import TempiRisposta from './components/TempiRisposta';
import ContattiDiretti from './components/ContattiDiretti';
import ContattiCTA from './components/ContattiCTA';
import { useSEO } from '../../utils/seo';

export default function ContattiPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://brandcapital.it';
  
  useSEO({
    title: 'Contatti - Richiedi Pre-Analisi Gratuita Valutazione Brand Italia',
    description: 'Contattaci per una pre-analisi gratuita del valore del tuo brand. Consulenza specializzata per aziende, commercialisti e investitori. Rispondiamo entro 24 ore in tutta Italia.',
    keywords: 'contatti valutazione brand, pre-analisi gratuita, consulenza brand, richiesta perizia marchio',
    canonical: `${siteUrl}/contatti`,
    schema: {
      '@context': 'https://schema.org',
      '@type': 'ContactPage',
      name: 'Contatti Brand Capital',
      description: 'Contattaci per una pre-analisi gratuita del valore del tuo brand',
      publisher: {
        '@type': 'Organization',
        name: 'Brand Capital',
        logo: {
          '@type': 'ImageObject',
          url: `${siteUrl}/logo.png`
        }
      }
    }
  });

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <ContattiHero />
      <FormConsulenza />
      <PreAnalisiInfo />
      <TempiRisposta />
      <ContattiDiretti />
      <ContattiCTA />
      <Footer />
    </div>
  );
}
